import React from 'react';
import { observer } from 'mobx-react';
import Button from '@mui/material/Button';

import { useStores } from '../../Hooks';
import { routes } from '../../App';
import { WorkspaceFlags, permissionsEnum } from '../../serverClientShared/sharedEnums';
import sharedUtils from '../../serverClientShared/sharedUtils';
import GlobalUtility from '../../Utilities/GlobalUtility';
import ConditionalComponent from './ConditionalComponent';

const RemoteSupportButton = observer(() => {
    const { generalStore } = useStores();

    const userWorkspaceDetails = generalStore.userDetails?.Domains?.[generalStore.workspace];
    const canRemoteSupport = GlobalUtility.isFlagOn(generalStore, WorkspaceFlags.Remote_Support_web)
        && sharedUtils.checkWorkspacePermission(userWorkspaceDetails, permissionsEnum.CREATE_REMOTE_SUPPORT, generalStore.domainSettings);

    const handleOpen = async () => {
        await generalStore.checkPermission(permissionsEnum.CREATE_REMOTE_SUPPORT);
        window.open(routes.CREATE_SUPPORT_ROOM);
    };

    return (
        <ConditionalComponent if={canRemoteSupport}>
            <Button
                onClick={handleOpen}
                className='frontline-ar-button hide-in-mobile hide-in-tablet'
            >
                {generalStore.translate('remoteSupport')}
            </Button>
        </ConditionalComponent>
    );
});

export default RemoteSupportButton;
